import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Tasks from './pages/tasks/Tasks';
import Activity from './pages/activity/Activity';
import Payments from './pages/payments/Payments';
import GlobalProvider from './context/GlobalProvider';
import Charges from './pages/charges/Charges';
import Rate from './pages/rate/Rate';
import Users from './pages/users/Users';
// import Projects from './pages/projects/Projects';
import Login from './login/Login';
import { startTokenExpirationCheck } from './login/AuthUtils';
import InactivityLogout from './login/InactivityLogout';
// import Logout from './login/Logout';
import ProfileLogout from './login/Logout';
// import AdminPanel from './pages/admin/AdminPanel';
import UnderConstruction from './login/undercontruction';
import Topbar from "./pages/topbar/Topbar"

// admipanel routes
import UploadPage from "./pages/admin/AdminUpload";
import TaskPage from "./pages/admin/AdminTask";
import ActivityPage from "./pages/admin/AdminActivity";
import ChargesPage from "./pages/admin/AdminCharges";

// reports
import Account from "./pages/accounts/Accounts";
import UserReport from "./pages/reports/UserReport";
import ProjectReport from "./pages/reports/ProjectReport";

const App = () => {
  const [isLogin, setIsLogin] = useState(false);
  useEffect(() => {
    const authTokenAccess = localStorage.getItem("access_token");
    if (authTokenAccess && authTokenAccess.length > 0) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);

  useEffect(() => {
    startTokenExpirationCheck();
  }, []);


  return (
    <GlobalProvider>
      <BrowserRouter>
        {isLogin ? (
          <Sidebar>
            <Topbar />
            <Routes>
              <>
                <Route path="/" element={<Tasks />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/charges" element={<Charges />} />
                <Route path="/rate" element={<Rate />} />
                {/* <Route path="/users" element={<Users />} /> */}
                {/* <Route path="/projects" element={<Projects />} /> */}
                {/* <Route path="/register" element={<Register />} /> */}
                <Route path="/register" element={<UnderConstruction />} />
                <Route path="/profile" element={<ProfileLogout />} />
                {/* <Route path="/admin" element={<AdminPanel />} /> */}
                
                <Route path="/admin/upload" element={<UploadPage />} />
                <Route path="/admin/task" element={<TaskPage />} />
                <Route path="/admin/activity" element={<ActivityPage />} />
                <Route path="/admin/charges" element={<ChargesPage />} />
                <Route path="/admin/users" element={<Users />} />


                {/* 🆕 New Routes */}
                <Route path="/account" element={<Account />} />
                <Route path="/report/user" element={<UserReport />} />
                <Route path="/report/project" element={<ProjectReport />} />
              </>
            </Routes>
          </Sidebar>
        ) : (
          <Routes>
            <Route path="*" element={<Login />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/register" element={<UnderConstruction />} />
          </Routes>

        )}
         <InactivityLogout />
      </BrowserRouter>
    </GlobalProvider>
  );
};

export default App;
